export const ErrorRetry = ({ message, onRetry }) => {
  return (
    <div className="col-span-full text-red-500 flex flex-col items-center gap-3">
      <span className="text-center">{message}</span>
      <button
        onClick={onRetry}
        className="px-5 py-2 bg-blue-600 text-white font-medium rounded shadow hover:bg-blue-700 hover:scale-105 transition-transform duration-150"
      >
        Retry
      </button>
    </div>
  );
};
